// extracted by mini-css-extract-plugin
export default {"overflowTextColumn":"device-details-table_overflowTextColumn__djw1B"};